/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { get, map, find } from "lodash";

import {
  Chip,
  Pagination,
  Stack,
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { LocalGasStation, Speed } from '@mui/icons-material';

import Layout from "../../../components/layout/Layout"
import Table from "../../../components/form/TableFilter";
import Toolbar from "./Toolbar";
import Notification from "../../../components/form/Notification";
import { PageSize, countPage } from "../../../config/const"

import { getReportInvoices } from "../../../store/reports/thunk/invoices/getAll";


const ReportInvoices = () => {
  const [__] = useTranslation("invoices");
  const dispatch = useDispatch();
  const routeStatus = __(`routeStatus`, { returnObjects: true });

  const [filter, setFilter] = useState({});
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })

  const invoices = useSelector(state => state.reports.invoices);

  const getData = ({page, filters = filter}) => {
    dispatch(getReportInvoices({page, ...filters}))
  }

useEffect(() => {
  reload();
}, [])


  const reload = () => {
    getData({ page: 1 });
  }

  const onFilterChange = (key, value) => {
    const updatedFilters = { ...filter, [key]: value };
    setFilter(updatedFilters);
    getData({ page: 1, filters: updatedFilters });
  };
  // useEffect(() => {
  //   // console.log("Esto traigo en el till: ",filter);
  //   if (filter.from && filter.till) {
  //     getData({ page: 1, filter })
  //   } else {
  //     getData({ page: 1, filter:""});
  //   }
  // }, [dispatch, JSON.stringify(filter)])

  const headTable = [
    {
      key: "statusId",
      label: __(`table.cols.status`),
      align: "center"
    },
    {
      key: "idRoute",
      label: __(`table.cols.idRoute`),
      align: "center"
    },
    {
      key: "dateToRoute",
      label: __(`table.cols.dateToRoute`),
      align: "center",
      sx: { minWidth: 150 }
    },
    {
      key: "routeName",
      label: __(`table.cols.routeName`),
      align: "center",
     // sx: { minWidth: 100 }
    },
    {
      key: "customerId",
      label: __(`table.cols.customerId`),
      align: "center"
    },
    {
      key: "customerName",
      label: __(`table.cols.customerName`),
      align: "center"
    },
    {
      key: "provider",
      label: __(`table.cols.provider`),
      align: "center"
    },
    {
      key: "division",
      label: __(`table.cols.division`),
      align: "center"
    },
    {
      key: "tonelaje",
      label: __(`table.cols.tonelaje`),
      align: "center"
    },
    {
      key: "driver",
      label: __(`table.cols.driver`),
      align: "center"
    },
    {
      key: "plate",
      label: __(`table.cols.plate`),
      align: "center"
    },
    {
      key: "fleetMix",
      label: __(`table.cols.fleetMix`),
      align: "center",
      sx: { minWidth: 100 }
    },
    {
      key: "deliveryPointStart",
      label: __(`table.cols.deliveryPointStart`),
      align: "center"
    },
    {
      key: "deliveryPointEnd",
      label: __(`table.cols.deliveryPointEnd`),
      align: "center"
    },
    {
      key: "deliveryPointStartMuni",
      label: __(`table.cols.deliveryPointStartMuni`),
      align: "center"
    },
    {
      key: "deliveryPointEndMuni",
      label: __(`table.cols.deliveryPointEndMuni`),
      align: "center"
    },
    {
      key: "billing",
      label: __(`table.cols.billing`),
      align: "center",
      sx: { minWidth: 100 }
    },
    {
      key: "cost",
      label: __(`table.cols.cost`),
      align: "center",
      sx: { minWidth: 100 }

    },
    {
      key: "kilometersEstimate",
      label: __(`table.cols.kilometersEstimate`),
      align: "center"
    },
    {
      key: "fuelGallons",
      label: __(`table.cols.fuelGallons`),
      align: "center"
    },
    {
      key: "statusOdooClient",
      label: __(`table.cols.statusOdooClient`),
      align: "center"
    },
    {
      key: "dteClient",
      label: __(`table.cols.dteClient`),
      align: "center"
    },
    {
      key: "totalClient",
      label: __(`table.cols.totalClient`),
      align: "center",
      sx: { minWidth: 100 }
    },
    {
      key: "statusOdooProvider",
      label: __(`table.cols.statusOdooProvider`),
      align: "center"
    },
    {
      key: "dteProvider",
      label: __(`table.cols.dteProvider`),
      align: "center"
    },
    {
      key: "totalProvider",
      label: __(`table.cols.totalProvider`),
      align: "center",
      sx: { minWidth: 100 }
    },
  ]

  const dataTable = map(get(invoices, "data.data", []), (row, i) => ({
    ...row,
    statusId: <Chip label={get(find(routeStatus, ({ value }) => value === get(row, "statusId", 1)), "label")} sx={{ bgcolor: `${get(find(routeStatus, ({ value }) => value === get(row, "statusId", 1)), "color")}26`, color: get(find(routeStatus, ({ value }) => value === get(row, "statusId", 1)), "color") }} />,
    dateToRoute:  new Date(get(row, "dateToRoute")).toISOString().split('T')[0],
    cost: `$ ${get(row, "cost", 0)?.toFixed(2)}`,
    billing: `$ ${get(row, "billing", 0)?.toFixed(2)}`,
    kilometersEstimate: `${get(row, "kilometersEstimate", 0.0)} Km`,
    fuelGallons: `${get(row, "fuelGallons", 0.00)} Gls`,
    totalClient: `$ ${get(row, "totalClient", 0)?.toFixed(2)}`,
    totalProvider: `$ ${get(row, "totalProvider", 0)?.toFixed(2)}`,
   // total: `$${get(row, "total")}`,
  }))

  const onChangePagination = (e, page) => getData({ page, filter })

  return (
    <Layout
      propsToolbar={{
        title: __(`head.name`),
        code: null,
        btnLabel: null
      }}
    >
      <Toolbar parameters={getData} __={__} reload={reload} isLoading={get(invoices, "isLoading", false)} />
      <Table headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        propsTable={{ showFilterRow: true }}
        filters={filter}
        onFilterChange={onFilterChange}
        loading={get(invoices, "isLoading", false)}
      />
      <Stack sx={{ mt: 2 }} alignItems="flex-end">
        <Pagination
          count={countPage(get(invoices, "data.totalRecord", 1))}
          page={get(invoices, "data.currentPage", 1)}
          onChange={onChangePagination}
          color="secondary"
          sx={{ "& li > button": { borderRadius: 1 } }}
          disabled={get(invoices, "isLoading", false)}
        />
      </Stack>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
    </Layout >
  )
}

export default ReportInvoices;


